import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import { map,catchError,delay } from 'rxjs/operators';
import { PurchaseOrder } from '../types/purchase-order';
import { EnvService } from '../services/env.service';
;

const httpOptions= {headers: new HttpHeaders({'Content-Type':'application/json'}) };

@Injectable({
  providedIn: 'root'
})
export class PurchaseOrderService {

  constructor(private http: HttpClient,private env: EnvService ) { }

  getMaxId() :Observable <any[]>{
     return this.http.get<any[]>(`${this.env.apiUrl}/purchase-orders/getMaxId`,httpOptions)
     .pipe(catchError(this.handleError));
        
     }

   getAll():Observable <PurchaseOrder[]> {
    return this.http.get <PurchaseOrder[]>(`${this.env.apiUrl}/purchase-orders`,httpOptions)
    .pipe(catchError(this.handleError));
       
    }


    getPurchaseOrder(poNo):Observable <PurchaseOrder> {
      return this.http.get<PurchaseOrder>(`${this.env.apiUrl}/purchase-orders/${poNo}`,httpOptions)
      .pipe(catchError(this.handleError));
         
      }



    addPurchaseOrder(data):Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/purchase-orders`, data ,httpOptions)
        .pipe(catchError(this.handleError));
       
    }


    deletePurchaseOrder(poNo: string) : Observable <void>{
      return this.http.delete<void>(`${this.env.apiUrl}/purchase-orders/${poNo}`,httpOptions)
        .pipe(catchError(this.handleError));
       
    }

    private handleError(errorResponse: HttpErrorResponse) {
      return throwError(errorResponse || "Server Error");

      }       





}
